import { render, staticRenderFns } from "./w4d.vue?vue&type=template&id=e5f47834&lang=pug&"
import script from "./w4d.vue?vue&type=script&lang=js&"
export * from "./w4d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports